import Impression from '~/app/components/common/Impression'
import React from 'react'
import { styled } from '~/app/components'

const ImageContent = styled.div<{ url: string }>`
  width: 100%;
  height: 5.3rem;
  background-image: url(${({ url }) => url});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  cursor: pointer;
  border-radius: 0.8rem;
`

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.color.white};
  max-width: ${({ theme }) => theme.unit.PC_WIDTH}px;
  margin: 0 auto;
  padding: 0 2rem;
`

type BenefitBannerProps = {
  url: string
  onImpressed?: () => void
  onClick?: () => void
}

/**
 * @description joy API 로 부터 받아오는 benefit banner 를 렌더링하는 컴포넌트
 * @link https://www.figma.com/file/sIi59fxY94OdjQHHvrJejw/%5BGUIDE%5D-%EA%B5%AD%EB%82%B4%EC%88%99%EC%86%8C-%EC%84%9C%EB%B8%8C%ED%99%88?node-id=7478%3A61705&mode=dev
 * @param url
 * @param onImpressed
 * @param onClick
 */
const BenefitBanner = ({ url, onImpressed, onClick }: BenefitBannerProps) => {
  return (
    <Impression onImpressed={onImpressed}>
      <Wrapper>
        <ImageContent url={url} onClick={onClick} />
      </Wrapper>
    </Impression>
  )
}

export default BenefitBanner
